import utils from '@/utils'

/**
 * 金額フィルター
 */
export default (value) => {
  const intVal = utils.cast.int(value)
  if (intVal === null) {
    return
  }

  return utils.string.commaNumber(value)
}
